<div class="row">
    <form [formGroup]="resourcesForm">
        <div class="follow-up">
            @if (showLabel) {
            <div class="follow-up-title">
                Follow-Up
            </div>
            }
            <div class="priority-follow-up">
                <mat-form-field class="priority">
                    <mat-select panelClass="recruiter-panel-class" disableOptionCentering="true" class="priority-select"
                        formControlName="priorityList" (selectionChange)="selectionPriorityChange($event.value)">
                        <mat-select-trigger>
                            <mat-icon [ngClass]="priority?.class">{{priority?.icon}}</mat-icon>
                            <span>{{priority?.value}}</span>
                        </mat-select-trigger>
                        @for (priority of priorityList; track priority) {
                        <mat-option class="select-option" [value]="priority">
                            <mat-icon [ngClass]="priority?.class" class="inner-prefix">{{priority?.icon}}</mat-icon>
                            {{ priority?.name }}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="whitelisted calendar">
                    <input matInput placeholder="MM/DD/YYYY" [mask]="shortDateMask" [leadZeroDateTime]="true"
                        [dropSpecialCharacters]="false" formControlName="date" />
                    <mat-icon (click)="toggleCalendar($event)" matSuffix>event</mat-icon>
                </mat-form-field>
            </div>
            <div class="time-wrap">
                <mat-form-field class="timer">
                    <mat-select panelClass="recruiter-panel-class" disableOptionCentering="true" class="time"
                        formControlName="time">
                        @for (hour of hours; track hour) {
                        <mat-option [value]="hour">
                            {{ hour.followupTime }}</mat-option>
                        }
                    </mat-select>
                    <mat-icon class="suffix">schedule</mat-icon>
                </mat-form-field>
            </div>
            @if (!showFollowupReason) {
            <div [@balloonEffect]=currentState class="saved-status">
                <mat-icon class="material-icons">check_circle</mat-icon>
                <span>Saved</span>
            </div>
            } @else {
            <span class="saved-status"></span>
            }
        </div>
        <div class="followup-error-warn">
            @if (resourcesForm?.controls?.date?.invalid && resourcesForm?.controls?.date?.dirty) {
            <mat-error>This date is invalid</mat-error>
            }
        </div>
        @if (showFollowupReason) {
        <div class="saved-status-right">
            <div [@balloonEffect]=currentState class="saved-status">
                <mat-icon class="material-icons">check_circle</mat-icon>
                <span>Saved</span>
            </div>
        </div>
        }
        @if (showFollowupReason) {
        <div class="followup-reason">
            @if (showLabel) {
            <div class="follow-up-title">
                <span>&nbsp;</span>
            </div>
            }
            <mat-form-field class="app-form-field app-form-field-with-border">
                <input matInput #reason formControlName="followupReason" maxlength="50" (blur)="onReasonBlur()"
                    placeholder="Reason (optional)">
                <mat-hint align="end">{{ reason?.value?.length }} / 50</mat-hint>
                @if (hasError('followupReason', 'maxlength')) {
                <mat-error>Max 50 characters</mat-error>
                }
            </mat-form-field>
        </div>
        }
        @if (showFollowupReason) {
        <div class="followup-actions" style="padding:10px;">
            @if (showLabel) {
            <div class="follow-up-title">
                <span>&nbsp;</span>
            </div>
            }
            <div>
                <button mat-stroked-button color="secondary" [disabled]="isMarkedComplete()"
                    (click)="openMarkAsCompleteDialog()">
                    <span matTooltip="Add a follow-up date to complete" [matTooltipDisabled]="!isMarkedComplete()">
                        MARK AS COMPLETE
                    </span>
                </button>
            </div>
        </div>
        }
    </form>
    @if (showCalendar) {
    <div clickOutside (clickOutside)="clickOutside()" class="calendar-wrapper">
        <div class="flex-display gap-em-1 items-center">
            <span>Follow-Ups Scheduled</span>
            <mat-chip-listbox>
                <mat-chip color="success">0-20</mat-chip>
                <mat-chip color="warning">21-40</mat-chip>
                <mat-chip color="error">41+</mat-chip>
            </mat-chip-listbox>
        </div>
        <calendar (selectedDate)="updateDate($event)" [followupDates]="followupsByDay" [selectedDates]="selectedDates"
            (dateChanged)="selectedDateChanged($event)"></calendar>
    </div>
    }
</div>